export enum TYPE_QUALITE {
    SALARIE = 'SALARIE',
    EMPLOYEUR = 'EMPLOYEUR'
}
